var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7803 2.21967C11.0732 2.51256 11.0732 2.98744 10.7803 3.28033L4.56066 9.5H17.75C18.1642 9.5 18.5 9.83579 18.5 10.25C18.5 10.6642 18.1642 11 17.75 11H4.56066L10.7803 17.2197C11.0732 17.5126 11.0732 17.9874 10.7803 18.2803C10.4874 18.5732 10.0126 18.5732 9.71967 18.2803L2.21967 10.7803C1.92678 10.4874 1.92678 10.0126 2.21967 9.71967L9.71967 2.21967C10.0126 1.92678 10.4874 1.92678 10.7803 2.21967Z",
    fill: "#2C2C2C",
    fillOpacity: 0.6,
    stroke: "#2C2C2C",
    strokeOpacity: 0.6,
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.c09992c58fd7b4869bd4d1af8136630c.svg";
export { ForwardRef as ReactComponent };